import { Illustration, Text } from "@clipboard-health/ui-components";
import { CardContent, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { type Shift } from "@src/appV2/Shifts/Shift/types";
import { useGetFacilityBreakConfiguration } from "@src/appV2/Shifts/Shift/useGetFacilityBreakConfiguration";

import { ShiftDetailsInnerCard } from "./InnerCard";

interface MandatoryBreakCardProps {
  shift: Pick<Shift, "start" | "end" | "facility">;
  isMandatoryBreakRequired: boolean;
  onViewWorkplacePolicies: () => void;
}

export function MandatoryBreakCard(props: MandatoryBreakCardProps) {
  const { shift, isMandatoryBreakRequired, onViewWorkplacePolicies } = props;

  const { mandatoryBreakDurationInMinutes } = useGetFacilityBreakConfiguration({
    workplaceId: shift.facility?.userId,
  });

  if (!isMandatoryBreakRequired) {
    return null;
  }

  return (
    <ShiftDetailsInnerCard
      footer={
        <Button fullWidth variant="outlined" size="medium" onClick={onViewWorkplacePolicies}>
          View workplace policies
        </Button>
      }
    >
      <CardContent>
        <Stack spacing={4} alignItems="center" sx={{ paddingX: 4, paddingY: 4 }}>
          <Illustration type="break" />
          <Text semibold variant="h5" sx={{ textAlign: "center" }}>
            A {mandatoryBreakDurationInMinutes}-minute unpaid break is required
          </Text>
          <Text
            variant="body2"
            sx={{ color: (theme) => theme.palette.text.secondary, textAlign: "center" }}
          >
            Break time will be automatically applied to your timesheet after clock out.
          </Text>
        </Stack>
      </CardContent>
    </ShiftDetailsInnerCard>
  );
}
